<template>
  <div class="page">
    <img src="../assets/image/not-found.png" alt="">
    <div class="tip">
      功能暂未开放
    </div>
    <div class="sub-tip">
      如有疑问请联系客服
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppNotOpen',
  computed: {},
  methods: {},
}

</script>
<style lang='less' scoped>
.page {
  display: flex;
  height: 100vh;
  background: #fff;
  flex-direction: column;
  align-items: center;
  padding-top: 30vh;
  img {
    height: 200px;
    width: 200px;
  }
  .tip {
    margin-top: 40px;
    font-weight: bold;
    color: #262626;
    font-size: 36px;
  }
  .sub-tip {
    margin-top: 26px;
    font-size: 26px;
    color: #999999;
  }
}
</style>